import React, { Component } from 'react';
import { Modal, Tree, Spin, Button, Input, message } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import './MoveToOtherFolderDialog.scss';
import intl from 'react-intl-universal';
import { store } from 'Store/store.index';
import { storageAppApi } from "Api/index";
const { TreeNode } = Tree;

class MoveToOtherFolderDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selected: '',
            treeData: null, // 树形数据
            isLoading: false,
            parentFolderPathes: [], // 父级文件夹名称
            addFolderState: undefined, // 创建文件夹状态 success/fail/doing
        };
        this.rootFolderName = intl.get('Home.Sider.Documents');
        this.treeRef = React.createRef();
        this.inputRef = React.createRef();
    }
    componentDidMount () {
        this.getTreeData();
    }
    getTreeData () {
        const root = this.props.root;
        const sources = this.props.sources;
        const parentFolderPathes = this.getParentFolderPathes(sources);
        this.setState({ isLoading: true, parentFolderPathes });
        root.name = this.rootFolderName;
        storageAppApi.getFolderTree(root.objectId, sources.map(item => item.docId)).then(treeData => {
            root.children = treeData;
            this.setState({
                treeData: root
            });
        }).finally(() => {
            this.setState({ isLoading: false });
        });
    }
    findTreeItemById (objectId) {
        const treeData = this.state.treeData;
        if (!treeData || !objectId) return ;
        const loop = (treeItem, parentItem) => {
            if (parentItem) {
                treeItem.parents = [...(parentItem.parents || []), parentItem];
            }
            if (treeItem.objectId === objectId) {
                return treeItem;
            } else if (treeItem.children) {
                const array = treeItem.children;
                for (let index = 0; index < array.length; index++) {
                    const item = array[index];
                    const ret = item && loop(item, treeItem);
                    if (ret) {
                        return ret;
                    }
                }
            }
        }
        return loop(treeData);
    }
    handleOk () {
        const { selected } = this.state;
        if (!selected || selected.length === 0) {
            store.appStore.setGlobalMessage({
                type: 'error', 
                content: intl.get('FoxitStorage.Error.SelectFirst'), 
                duration: 2
            });
            return ;
        }
        const onConfirm = this.props.onConfirm;
        onConfirm && onConfirm(selected[0]);
    }
    handleAddFolder () {
        const treeData = this.state.treeData;
        const parentId = this.getParentId();
        const treeItem = this.findTreeItemById(parentId);
        
        if (!treeItem) return ;
        this.setState({ addFolderState: 'doing' });
        if (!treeItem.children) treeItem.children = [];
        const children = treeItem.children || [];
        const folderInfo = {
            "objectId": "",
            "name": intl.get('HeaderContainer.untitled') + ' ' + (children.length + 1),
            "parentId": parentId,
            "children": []
        }
        children.push(folderInfo);
        this.setState({ treeData });
        const $treeRef = this.treeRef;
        const $inputRef = this.inputRef;
        if ($treeRef) {
            $treeRef.current.setExpandedKeys([...(treeItem.parents || []).map(item => item.objectId), parentId]);
            setTimeout(() => { $inputRef && $inputRef.current.focus({ cursor: 'start' }) }, 300);
        }
    }
    doAddFolder (e, itemData) {
        const parentId = itemData.parentId;
        const treeData = this.state.treeData;
        const treeItem = this.findTreeItemById(parentId);
        const children = treeItem && treeItem.children;
        if (!children || children.length === 0) return ;
        let newFolderIndex = -1;
        for (let index = children.length - 1; index > -1; index--) {
            const element = children[index];
            if (!element.objectId) {
                newFolderIndex = index;
                break;
            }
        }
        if (newFolderIndex === -1) return ;
        const lastFolderName = e.target.value;
        if (store.storageAppStore.regExpName(lastFolderName)) {
            this.setState({ addFolderState: 'fail' });
            return ;
        }
        this.setState({ isLoading: true });
        storageAppApi.createFolder(parentId, lastFolderName).then((data) => {
            children.splice(newFolderIndex, 1, data);
            this.setState({ treeData, addFolderState: 'success' });
        }).finally(() => {
            this.setState({ isLoading: false });
        }).catch(() => {
            this.setState({ addFolderState: 'fail' });
            message.error(intl.formatMessage({
                id: 'FoxitStorage.Error.DuplicateFolderName'
            }, {
                folderName: lastFolderName
            }))
        });
    }
    getParentId () {
        let [ parentId ] = this.state.selected;
        if (!parentId) {
            const treeData = this.state.treeData;
            parentId = treeData.objectId;
        }
        return parentId;
    }
    doHide () {
        const hide = () => {
            const onHide = this.props.onHide;
            onHide && onHide(this.state.addFolderState === 'success');
        }
        if (this.state.addFolderState === 'doing') {
            // 有正在新增的文件夹，等待新增完成再关闭窗口
            const timer = setInterval(() => {
                if (this.state.addFolderState !== 'doing') {
                    clearInterval(timer);
                }
                if (this.state.addFolderState === 'success') {
                    hide();
                }
            }, 50);
        } else {
            hide();
        }
    }
    onTreeSelect (key) {
        this.setState({ selected: key });
    }
    renderTreeNode (treeItemData) {
        if (!treeItemData) return ;
        // const parentFolderPathes = this.state.parentFolderPathes;
        // disabled={parentFolderPathes.indexOf(treeItemData.path)>-1}
        const itemName = treeItemData.name;
        const objectId = treeItemData.objectId;
        const renderTitle = () => {
            return (
                objectId ? <a className="wc-icon folder-open" data-text={itemName} />
                : <a className="wc-icon folder-open"><Input ref={this.inputRef} size="small" defaultValue={itemName} onPressEnter={e=>this.doAddFolder(e,treeItemData)} onBlur={e=>this.doAddFolder(e,treeItemData)} /></a>
            )
        }
        return (
            <TreeNode title={renderTitle()} key={treeItemData.objectId}>
                {
                    (treeItemData.children || []).map(item => {
                        return this.renderTreeNode(item);
                    })
                }
            </TreeNode>
        )
    }
    getParentFolderPathes (sources) {
        if (!sources || sources.length === 0) return [];
        return sources.map(item => {
            let path = item.path;
            path = path.substr(0, path.lastIndexOf('/'));
            return path;
        });
    }
    renderModalFooter () {
        const { selected, parentFolderPathes, addFolderState } = this.state;
        const [ objectId ] = selected;
        const treeItemData = this.findTreeItemById(objectId);
        const disabled = treeItemData && parentFolderPathes.indexOf(treeItemData.path) > -1;
        return (<>
            <div>
                <Button onClick={()=>this.doHide()}>{intl.get("Cancel")}</Button>
                <Button type="primary" disabled={disabled} onClick={()=>this.handleOk()}>{intl.get("Ok")}</Button>
            </div>
            <Button disabled={['doing', 'fail'].includes(addFolderState)} onClick={()=>this.handleAddFolder()}>{intl.get('FoxitStorage.MoveDialog.AddFolder')}</Button>
        </>)
    }
    render () {
        const { treeData, isLoading } = this.state;

        return (
            <Modal className='move-folder-model' 
                title={intl.get('FoxitStorage.MoveDialog.Title')} 
                visible={this.props.visible} 
                footer={this.renderModalFooter()}
                onCancel={()=>this.doHide()}>
                <Spin tip="Loading..." spinning={isLoading}>
                    <div className='move-folder-main'>
                        <label>{intl.get('FoxitStorage.MoveDialog.MoveTo')}</label>
                        <div className='move-folder-tree'>
                            {
                                treeData && <Tree ref={this.treeRef} switcherIcon={<DownOutlined />} checkable={false} blockNode defaultExpandedKeys={[treeData.objectId]} onSelect={(e,f)=>this.onTreeSelect(e,f.node)}>
                                    {
                                        this.renderTreeNode(treeData)
                                    }
                                </Tree>
                            }
                        </div>
                    </div>
                </Spin>
            </Modal>
        );
    }
}
export default MoveToOtherFolderDialog;
